<script>
  import { urlParams } from '../base/store'
  import { debounce } from '../base/utils'
// Props
  export let key, text, value="true"
// Handlers
  const DELAY = 200
  const handle = debounce(DELAY, async e => {
    if (checked) urlParams.removeParam(key)
      else urlParams.setParam(key, value)
    await urlParams.applyFilters()
    console.log($urlParams)
  })
  $: checked = ($urlParams[key] || []).indexOf(value) > -1
</script>

<input type="checkbox" id="{key}-{value}" checked={checked} on:click={handle}>
  <label for="{key}-{value}">{text}</label>